import type { RefCallback } from "react";
import type { PageTypeDefinition } from "../../pageTypeRegistry";
import styles from "./PageLayoutField.module.css";

type PageLayoutFieldProps = {
  name: string;
  value: string;
  options: PageTypeDefinition[];
  onChange: (value: string) => void;
  error?: string;
  inputRef?: RefCallback<HTMLElement>;
};

export function PageLayoutField({
  name,
  value,
  options,
  onChange,
  error,
  inputRef,
}: PageLayoutFieldProps) {
  const errorId = `${name}-error`;
  const focusIndex = Math.max(
    options.findIndex(option => option.key === value),
    0,
  );

  return (
    <fieldset className={styles.layoutField} aria-describedby={error ? errorId : undefined}>
      <legend className={styles.legend}>
        Page layout <span className={styles.required}>*</span>
      </legend>

      <div className={styles.options}>
        {options.map((option, index) => {
          const nameId = `${name}-${index}-name`;
          const descriptionId = `${name}-${index}-description`;
          return (
            <label key={option.key} className={styles.option}>
              <input
                ref={index === focusIndex ? inputRef : undefined}
                type="radio"
                className={styles.radio}
                name={name}
                value={option.key}
                checked={value === option.key}
                onChange={() => onChange(option.key)}
                aria-labelledby={nameId}
                aria-describedby={descriptionId}
              />
              <span className={styles.optionText}>
                <span id={nameId} className={styles.optionName}>
                  {option.name}
                </span>
                <span id={descriptionId} className={styles.optionDescription}>
                  {option.description}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      {error && (
        <p id={errorId} className={styles.error} role="alert">
          {error}
        </p>
      )}
    </fieldset>
  );
}
